(function Module() {
'use strict';

var _ = require('lodash');

module.exports = {
	isAngularObjectEqual: function isAngularObjectEqual(object1, object2) {
		return _.isEqual(_.omit(object1, '$$hashKey'), _.omit(object2, '$$hashKey'));
	}
};
})();
